import { Outlet } from 'react-router-dom';

import { useRuntime } from '@/legacy/components/RuntimeProvider';

import { CockpitPanelPaper, StyledPageLayout } from './Cockpit.styled';
import { CockpitContextProvider } from './components/CockpitContextProvider/CockpitContextProvider';
import { CockpitPageHeader } from './components/CockpitPageHeader/CockpitPageHeader';
import { CockpitPanel } from './components/CockpitPanel/CockpitPanel';

export const Cockpit = () => {
  const { runtime } = useRuntime();
  const shouldShowHeaderAndSidePanel = runtime.type !== 'browserExtension';

  return (
    <CockpitContextProvider>
      <StyledPageLayout
        disablePadding
        fullHeight
        renderHeader={shouldShowHeaderAndSidePanel ? <CockpitPageHeader /> : null}
      >
        {shouldShowHeaderAndSidePanel && (
          <CockpitPanelPaper variant="outlined" square elevation={0}>
            <CockpitPanel />
          </CockpitPanelPaper>
        )}
        <Outlet />
      </StyledPageLayout>
    </CockpitContextProvider>
  );
};
